import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import * as languages from "../constants/languages";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../constants/strings";
import { Container, Column, Row } from "../grid";
import Dropdown from "./Dropdown";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	container: {
		backgroundColor: colors.pink,
	},
	contentContainer: {
		display: "flex",
		paddingTop: 20,
		paddingBottom: 16,
		alignItems: "center",
		[breakpoints.mobileOnly]: {
			flexDirection: "column",
			alignItems: "flex-start",
		},
	},
	dropdown: {
		width: "100%",
		[breakpoints.tabletAndUp]: {
			maxWidth: 375,
		},
	},
	dropdownLabel: {
		fontSize: 30,
		lineHeight: 0.63,
		color: colors.black3,
		marginRight: 32,
		fontFamily: "priori-sans",
		[breakpoints.mobileOnly]: {
			marginBottom: 15,
		},
	},
});

export default class FilterBar extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
		selectedValue: PropTypes.string.isRequired,
		selectValue: PropTypes.func.isRequired,
		options: PropTypes.array.isRequired,
	};

	constructor(props) {
		super(props);
		this.strings = props.language === languages.es ? spanish : english;
	}

	render() {
		return (
			<div className={css(styles.container)}>
				<Container>
					<Row>
						<Column>
							<div className={css(styles.contentContainer)}>
								<label className={css(styles.dropdownLabel)}>
									{this.strings.Filter}
								</label>
								<Dropdown
									className={css(styles.dropdown)}
									options={this.props.options}
									selectedValue={this.props.selectedValue}
									selectValue={this.props.selectValue}
								/>
							</div>
						</Column>
					</Row>
				</Container>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/FilterBar.js